import * as React from 'react';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import { InvoicePaymentStatus } from 'types/plansales/billing';
import styled from 'styled-components';
import { paymentInvoiceStatusLabel } from 'constants/plansales/billing';
import { CheckObjectValue } from 'types/common';

interface Props {
  payStatus: CheckObjectValue;
  onChangePayStatus: (
    status: InvoicePaymentStatus,
  ) => (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const PayStatusFilters = ({ payStatus, onChangePayStatus }: Props) => {
  const payStatusCheckboxes: InvoicePaymentStatus[] = [
    InvoicePaymentStatus.Completed,
    InvoicePaymentStatus.Refunded,
    InvoicePaymentStatus.Pending,
    InvoicePaymentStatus.Uncollectible,
  ];
  return (
    <>
      {payStatusCheckboxes.map(status => (
        <FormControlLabel
          key={status}
          control={
            <Checkbox
              value={status}
              color={'primary'}
              checked={payStatus[status]}
              onChange={onChangePayStatus(status)}
            />
          }
          label={<LabelText>{paymentInvoiceStatusLabel[status]}</LabelText>}
        />
      ))}
    </>
  );
};

export default PayStatusFilters;

export const LabelText = styled.span`
  text-transform: capitalize;
`;
